import ReactDOM from "react-dom";
import styles from "./app-modal.module.scss";

interface IProps {
  show: boolean;
  children: JSX.Element;
  size?: "modal-sm" | "modal-lg" | "modal-md" | "modal-xl";
}

const AppModal = (props: IProps) => {
  if (typeof document === "undefined") {
    return null;
  }

  const portalRoot = document.getElementById("modal-root") || document.body;

  return ReactDOM.createPortal(
    <div
      className={`${
        props.show
          ? `${styles["showing-modal"]}`
          : `${styles["not-showing-modal"]}`
      } ${styles["app-modal-backdrop"]} px-3`}
    >
      <div
        // popovers (e.g. AppDatePicker) keep themselves inside this card
        data-popover-boundary=""
        className={`${styles[`${props.size}`] || styles["modal-lg"]} ${
          styles["app-modal-container"]
        }`}
      >
        <div className={`${props.show ? "d-block" : "d-none"}`}>
          {props.children}
        </div>
      </div>
    </div>,
    portalRoot,
  );
};

export default AppModal;
